<ng-container>{{ format() }}</ng-container>
